import { render, staticRenderFns } from "./errorPopup.vue?vue&type=template&id=652e4b14&scoped=true&"
import script from "./errorPopup.vue?vue&type=script&lang=js&"
export * from "./errorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e4b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog})
